const COP_FORMATTER = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** es-CO separates the symbol from the amount with a non-breaking space. */
const NON_BREAKING_SPACE = new RegExp(String.fromCharCode(160), 'g');

/**
 * Formats a value as Colombian pesos ($1.234.567,89).
 * Non-finite values fall back to zero so a table cell never prints NaN.
 */
export function formatCop(value: number | string | null | undefined): string {
  const amount = typeof value === 'string' ? Number(value) : (value ?? 0);
  const safeAmount = Number.isFinite(amount) ? (amount as number) : 0;

  return COP_FORMATTER.format(safeAmount).replace(NON_BREAKING_SPACE, ' ');
}
